import axios from "axios";

//geospatial

export const baseBackend = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export const baseGeospatial = axios.create({
  baseURL: process.env.REACT_APP_API_GEOSPATIAL,
});

export const baseFcm = axios.create({
  baseURL: "https://fcm.googleapis.com/",
});

export const baseNotification = axios.create({
  baseURL: "https://alert.usa.pe/",
});

export const baseFCMNotification = axios.create({
  baseURL: process.env.REACT_APP_API_NOTIFICATION_URL,
});
